import { Helmet } from "react-helmet";

// import {useState} from 'react';
import SerHeader from "../component/serviceheader";
import arrowleft from "../asset/images/arrowleftcircle.svg";
import a1 from "../asset/images/letterofcredit/a1.svg";
import a3 from "../asset/images/letterofcredit/a3.svg";
import a4 from "../asset/images/letterofcredit/a4.svg";
import a5 from "../asset/images/letterofcredit/a5.svg";
import a6 from "../asset/images/letterofcredit/a6.svg";
import a7 from "../asset/images/letterofcredit/a7.svg";
import a8 from "../asset/images/tradecredit/a8.svg";
import InvoiceSuccess from "../component/invoicesuccess";
import Loader from "../component/loader";
import Swal from "sweetalert2/dist/sweetalert2.js";
import mark from "../asset/images/marksuccess.svg";

import { useEffect, useState } from "react";
import WayBill from "../component/trade/Waybill";
import FoerWaringDocument from "../component/trade/FoerwadingDocument";
import InsuranceCertificates from "../component/trade/InsuranceCertificate";
import Export from "../component/trade/Export";
import CertOrigin from "../component/trade/CertiOrigin";
import Packing from "../component/trade/packing";
import Inspection from "../component/trade/InspectionCertificate";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SuccessHolder from "../component/SuccessHolder";
import FailHandler from "../component/failhandler";
import { INTEREST } from "../utilities/ut";
import currencyPairCheck from "../utilities/currencyPairCheck";
import AmountCheck from "../component/amountCheck";

const TradeDocument = () => {
    // const [selectedIndex, setselectedIndex] = useState(-1)
    const navigate = useNavigate();
    const [isdisable, setisdisable] = useState(true);
    useEffect(() => {
        setisdisable(false);
    }, [setisdisable]);
    const { id } = useParams();
    const [showModal, setshowModal] = useState(false);
    const [showModal2, setshowModal2] = useState(false);
    const [showModal3, setshowModal3] = useState(false);
    const [showModal4, setshowModal4] = useState(false);
    const [showModal5, setshowModal5] = useState(false);
    const [showModal6, setshowModal6] = useState(false);
    const [showModal7, setshowModal7] = useState(false);
    const today = new Date();
    const [tab, settab] = useState("trade");
    const [waybill, setWaybill] = useState([]);
    const [waybillSize, setWaybillSize] = useState(0);

    const [ForwardingDocument, setForwardingDocument] = useState([]);
    const [forwardingDocumentSize, setForwardingDocumentSize] = useState(0);
    const [InsuranceCertificate, setInsuranceCertificate] = useState([]);
    const [InsuranceCertificateSize, setInsuranceCertificateSize] = useState(0);

    const [ExportImport, setExportInport] = useState([]);
    const [ExportImportSize, setExportInportSize] = useState(0);

    const [CertificateOrigin, setCertificateOrgin] = useState([]);
    const [CertificateOriginSize, setCertificateOrginSize] = useState(0);

    const [PackingList, setPackingList] = useState([]);
    const [PackingListSize, setPackingListSize] = useState(0);

    const [InspectCertificate, setInspectCertificate] = useState([]);
    const [InspectCertificateSize, setInspectCertificateSize] = useState(0);
    const [loader, setloader] = useState(false);
    const [message, setmessage] = useState(false);
    const [success, setsuccess] = useState(false);
    const [tfess, settess] = useState(0);

    const [failhandler, setfailhandler] = useState(false);
    const { state } = useLocation();

    const HandleSubmit = async (e) => {
        e.preventDefault();
        setloader(true);
        const formdata = new FormData();
        formdata.append("airWayBill", waybill, waybill.name);

        formdata.append("certificateOfOrigin", CertificateOrigin, CertificateOrigin.name);

        formdata.append("insurance", InsuranceCertificate, InsuranceCertificate.name);

        formdata.append("inspectionCertificate", InspectCertificate, InspectCertificate.name);

        formdata.append("exportAndImportDocument", ExportImport, ExportImport.name);

        formdata.append("forwardingDocument", ForwardingDocument, ForwardingDocument.name);

        formdata.append("packingList", PackingList, PackingList.name);

        formdata.append("commercialInvoice", waybill, waybill.name);

        try {
            await axios.put(
                `v1/finance/trade_credit/create/${id}?type=shippingDocuments`,
                formdata
            );
            await axios.post(`/v1/finance/request_trade_credit/verification/${id}`);
            setshowModal3(true);
            setloader(false);
        } catch (e) {
            //console.log(e);
            setloader(false);

            if (!e.response) {
                // Network error
                setmessage("413 Payload Too Large");
            } else {
                // Server error
                setmessage(e.response.data.message);
            }

            setfailhandler(true);
        }
    };

    INTEREST()
        .then((res) => {
            //  console.log(res);
            settess(res.data.data.financeWorkingCapitalInterest);
        })
        .catch((e) => {
            console.log(e);
        });
    return (
        <>
            {tab === "trade" && (
                <div className="h-100 w-100 ">
                    <div
                        className=""
                        style={{
                            maxWidth: "2000px",
                            width: "100%",
                            margin: "0px auto",
                        }}
                    >
                        <Helmet>
                            <title>Working Capital</title>
                        </Helmet>

                        <SerHeader header={"Working Capital"} width={80} />
                        <WayBill
                            filesize={waybillSize}
                            show={showModal}
                            setshow={setshowModal}
                            filename={waybill}
                            setfilesize={setWaybillSize}
                            setfilename={setWaybill}
                        />

                        <FoerWaringDocument
                            filesize={forwardingDocumentSize}
                            show={showModal2}
                            setshow={setshowModal2}
                            filename={ForwardingDocument}
                            setfilesize={setForwardingDocumentSize}
                            setfilename={setForwardingDocument}
                        />
                        <InsuranceCertificates
                            filesize={InsuranceCertificateSize}
                            show={showModal3}
                            setshow={setshowModal3}
                            filename={InsuranceCertificate}
                            setfilesize={setInsuranceCertificateSize}
                            setfilename={setInsuranceCertificate}
                        />
                        <Export
                            filesize={ExportImportSize}
                            show={showModal4}
                            setshow={setshowModal4}
                            filename={ExportImport}
                            setfilesize={setExportInportSize}
                            setfilename={setExportInport}
                        />
                        <CertOrigin
                            filesize={CertificateOriginSize}
                            show={showModal5}
                            setshow={setshowModal5}
                            filename={CertificateOrigin}
                            setfilesize={setCertificateOrginSize}
                            setfilename={setCertificateOrgin}
                        />
                        <Packing
                            filesize={PackingListSize}
                            show={showModal6}
                            setshow={setshowModal6}
                            filename={PackingList}
                            setfilesize={setPackingListSize}
                            setfilename={setPackingList}
                        />
                        <Inspection
                            filesize={InspectCertificateSize}
                            show={showModal7}
                            setshow={setshowModal7}
                            filename={InspectCertificate}
                            setfilesize={setInspectCertificateSize}
                            setfilename={setInspectCertificate}
                        />
                    </div>
                    <div style={{ height: "100%" }}>
                        <div
                            className="conatiner "
                            style={{
                                maxWidth: "2000",
                                width: "100%",
                                margin: "0px auto",
                                paddingLeft: "30px",
                                paddingRight: "30px",
                                paddingTop: "10px",
                                paddingBottom: "10px",
                            }}
                        >
                            <div
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    display: "flex",

                                    justifyContent: "center",
                                }}
                            >
                                <div className="form-general-layout mb-5">
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "32px",
                                            maxWidth: "384px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "16px",
                                            }}
                                        >
                                            <div
                                                onClick={() => {
                                                    navigate(-1);
                                                }}
                                            >
                                                <img src={arrowleft} alt="" />
                                            </div>
                                            <div>
                                                <div
                                                    style={{
                                                        color: "#101828",
                                                        fontWeight: "600",
                                                        fontSize: "24px",
                                                        lineHeight: "32.4px",
                                                    }}
                                                >
                                                    Upload Documents
                                                </div>
                                                <div
                                                    style={{
                                                        color: "#667085",
                                                        fontSize: "16px",
                                                        lineHeight: "24px",
                                                        letterSpacing: "2%",
                                                        fontWeight: "500",
                                                        maxWidth: "500px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    Provide one of each of the following documents
                                                    so we can verify your transaction.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "16px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                            }}
                                        >
                                            <label
                                                htmlFor=""
                                                style={{
                                                    color: "#667085",
                                                    fontWeight: "600",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Required documents
                                            </label>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "8px",
                                                    flexDirection: "column",
                                                    display: "flex",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        borderBottom: "1px solid #E7E9FB",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    onClick={() => {
                                                        setshowModal(true);
                                                        setWaybill([]);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            gap: "8px",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <img src={a3} alt="" />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#101828",
                                                                    letterSpacing: "2%",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                }}
                                                            >
                                                                Waybill
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    lineHeight: "16.2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    letterSpacing: "2%",
                                                                }}
                                                            >
                                                                From supplier
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {waybill.length !== 0 ? (
                                                        <img src={mark} alt="" />
                                                    ) : (
                                                        <span className="material-icons">
                                                            chevron_right
                                                        </span>
                                                    )}
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        borderBottom: "1px solid #E7E9FB",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    onClick={() => {
                                                        setForwardingDocument([]);
                                                        setshowModal2(true);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            gap: "8px",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <img src={a1} alt="" />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#101828",
                                                                    letterSpacing: "2%",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                }}
                                                            >
                                                                Forwarding documents
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    lineHeight: "16.2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    letterSpacing: "2%",
                                                                }}
                                                            >
                                                                From supplier
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {ForwardingDocument.length !== 0 ? (
                                                        <img src={mark} alt="" />
                                                    ) : (
                                                        <span className="material-icons">
                                                            chevron_right
                                                        </span>
                                                    )}
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    onClick={() => {
                                                        setInsuranceCertificate([]);
                                                        setshowModal3(true);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            gap: "8px",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <img src={a4} alt="" />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#101828",
                                                                    letterSpacing: "2%",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                }}
                                                            >
                                                                Insurance Certificate
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    lineHeight: "16.2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    letterSpacing: "2%",
                                                                }}
                                                            >
                                                                From your insurer
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {InsuranceCertificate.length !== 0 ? (
                                                        <img src={mark} alt="" />
                                                    ) : (
                                                        <span className="material-icons">
                                                            chevron_right
                                                        </span>
                                                    )}
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    onClick={() => {
                                                        setshowModal4(true);
                                                        setExportInport([]);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            gap: "8px",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <img src={a8} alt="" />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#101828",
                                                                    letterSpacing: "2%",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                }}
                                                            >
                                                                Export and Import License
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    lineHeight: "16.2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    letterSpacing: "2%",
                                                                }}
                                                            >
                                                                From your country
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {ExportImport.length !== 0 ? (
                                                        <img src={mark} alt="" />
                                                    ) : (
                                                        <span className="material-icons">
                                                            chevron_right
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                            }}
                                        >
                                            <label
                                                htmlFor=""
                                                style={{
                                                    color: "#667085",
                                                    fontWeight: "600",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Other documents
                                            </label>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "8px",
                                                    flexDirection: "column",
                                                    display: "flex",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        borderBottom: "1px solid #E7E9FB",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    onClick={() => {
                                                        setshowModal5(true);
                                                        setCertificateOrgin([]);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            gap: "8px",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <img src={a5} alt="" />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#101828",
                                                                    letterSpacing: "2%",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                }}
                                                            >
                                                                Certificate of Origin
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    lineHeight: "16.2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    letterSpacing: "2%",
                                                                }}
                                                            >
                                                                From your country
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {CertificateOrigin.length !== 0 ? (
                                                        <img src={mark} alt="" />
                                                    ) : (
                                                        <span className="material-icons">
                                                            chevron_right
                                                        </span>
                                                    )}
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        borderBottom: "1px solid #E7E9FB",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    onClick={() => {
                                                        setPackingList([]);
                                                        setshowModal6(true);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            gap: "8px",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <img src={a6} alt="" />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#101828",
                                                                    letterSpacing: "2%",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                }}
                                                            >
                                                                Export Packing List
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    lineHeight: "16.2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    letterSpacing: "2%",
                                                                }}
                                                            >
                                                                From supplier
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {PackingList.length !== 0 ? (
                                                        <img src={mark} alt="" />
                                                    ) : (
                                                        <span className="material-icons">
                                                            chevron_right
                                                        </span>
                                                    )}
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    onClick={() => {
                                                        setInspectCertificate([]);
                                                        setshowModal7(true);
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            gap: "8px",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <img src={a7} alt="" />
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#101828",
                                                                    letterSpacing: "2%",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                }}
                                                            >
                                                                Inspection Certificate
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    lineHeight: "16.2px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    letterSpacing: "2%",
                                                                }}
                                                            >
                                                                From supplier
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {InspectCertificate.length !== 0 ? (
                                                        <img src={mark} alt="" />
                                                    ) : (
                                                        <span className="material-icons">
                                                            chevron_right
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            disabled={isdisable}
                                            variant="primary"
                                            style={{
                                                maxWidth: "280px",
                                                width: "100%",
                                                marginTop: "10px",
                                                background: isdisable ? "#EBE4FF" : "#6F00FF",
                                                padding: "16px 24px 16px 24px",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "8px",
                                                fontSize: "16px",
                                                lineHeight: "24px",
                                                letterSpacing: "2%",
                                                fontWeight: "500",
                                                minHeight: "46px",
                                                color: isdisable ? "#BFA6FF" : "#ffff",
                                            }}
                                            onClick={() => {
                                                if (
                                                    waybill.length !== 0 &&
                                                    ForwardingDocument.length !== 0 &&
                                                    InsuranceCertificate.length !== 0 &&
                                                    CertificateOrigin.length !== 0 &&
                                                    InspectCertificate.length !== 0 &&
                                                    ExportImport.length !== 0 &&
                                                    PackingList.length !== 0
                                                ) {
                                                    settab("summary");
                                                }
                                                //  navigate("/trade_of_credit/summary");
                                            }}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/***Summary */}

            {tab === "summary" && (
                <div className="h-100 w-100 ">
                    <div
                        className=""
                        style={{
                            maxWidth: "2000px",
                            margin: "0px auto",
                            width: "100%",
                        }}
                    >
                        <Helmet>
                            <title>Trade of credit</title>
                        </Helmet>

                        <SerHeader header={"Trade Credit"} width={100} />
                        <InvoiceSuccess
                            show={showModal3}
                            set={"finance"}
                            currency={state.currency}
                            amount={state.requestedAmount}
                            setshow={setshowModal3}
                            subject={"Application received! Your request is under review"}
                            title={`We’ll review your request of     ${currencyPairCheck(
                                state.currency
                            )}${AmountCheck(
                                state.requestedAmount
                            )}  in less than 48 hours. You’ll be notified on how to proceed from here.`}
                        />
                    </div>
                    <div style={{ height: "100%" }}>
                        <div
                            className="conatiner "
                            style={{
                                maxWidth: "2000px",
                                margin: "0px auto",
                                paddingLeft: "30px",
                                paddingRight: "30px",
                                paddingTop: "10px",
                                paddingBottom: "10px",
                            }}
                        >
                            <div
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    display: "flex",
                                    margin: "0px auto",
                                    justifyContent: "center",
                                    maxWidth: "384px",
                                    position: "relative",
                                }}
                            >
                                <div className="form-general-layout mb-5">
                                    <SuccessHolder success={success} message={message} />
                                    <FailHandler success={failhandler} message={message} />
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "32px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "16px",
                                            }}
                                        >
                                            <div
                                                onClick={() => {
                                                    settab("trade");
                                                }}
                                            >
                                                <img src={arrowleft} alt="" />
                                            </div>
                                            <div>
                                                <div
                                                    style={{
                                                        color: "#101828",
                                                        fontWeight: "500",
                                                        fontSize: "24px",
                                                        lineHeight: "32.4px",
                                                    }}
                                                >
                                                    Summary
                                                </div>
                                                <div
                                                    style={{
                                                        color: "#667085",
                                                        fontSize: "16px",
                                                        lineHeight: "24px",
                                                        letterSpacing: "2%",
                                                        fontWeight: "400",
                                                        maxWidth: "500px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    Please review your details before you continue.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <form
                                        onSubmit={HandleSubmit}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "16px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                            }}
                                        >
                                            <label
                                                htmlfor=""
                                                style={{
                                                    color: "#667085",
                                                    fontWeight: "400",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Loan details
                                            </label>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "8px",
                                                    flexDirection: "column",
                                                    display: "flex",
                                                }}
                                            >
                                                <div style={{ padding: "16px" }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "4px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                style: "#6F00FF",
                                                                fontWeight: "500",
                                                                fontSize: "12px",
                                                                lineHeight: "16.2px",
                                                                letterSpacing: "2%",
                                                            }}
                                                        >
                                                            Credit amount
                                                        </span>
                                                        <span
                                                            style={{
                                                                color: "#344054",
                                                                fontSize: "20px",
                                                                lineHeight: "24px",
                                                                fontWeight: "600",
                                                            }}
                                                        >
                                                            {currencyPairCheck(state.currency)}
                                                            {AmountCheck(state.requestedAmount)}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div style={{ gap: "8px", display: "flex" }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: "4px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    style: "#667085",
                                                                    fontWeight: "500",
                                                                    fontSize: "14px",
                                                                    lineHeight: "19.6px",
                                                                }}
                                                            >
                                                                Interest ({tfess}%)
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "#344054",
                                                                    fontSize: "14px",
                                                                    lineHeight: "19.6px",
                                                                    fontWeight: "500",
                                                                }}
                                                            >
                                                                {currencyPairCheck(state.currency)}
                                                                {parseFloat(state.requestedAmount) *
                                                                    tfess}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "4px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                style: "#667085",
                                                                fontWeight: "500",
                                                                fontSize: "12px",
                                                                lineHeight: "19.6px",
                                                            }}
                                                        >
                                                            Repay date
                                                        </span>
                                                        <span
                                                            style={{
                                                                color: "#101828",
                                                                fontSize: "14px",
                                                                lineHeight: "19.6px",
                                                                fontWeight: "500",
                                                            }}
                                                        >
                                                            {new Date(
                                                                today.setDate(
                                                                    today.getDate() +
                                                                        parseInt(state.tenure)
                                                                )
                                                            ).toDateString()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                            }}
                                        >
                                            <label
                                                htmlfor=""
                                                style={{
                                                    color: "#667085",
                                                    fontWeight: "400",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Documents
                                            </label>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "8px",
                                                    flexDirection: "column",
                                                    display: "flex",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div style={{ gap: "8px", display: "flex" }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    style: "#667085",
                                                                    fontWeight: "500",
                                                                    fontSize: "14px",
                                                                    lineHeight: "19.6px",
                                                                }}
                                                            >
                                                                Forward Document
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: "#6F00FF",
                                                            letterSpacing: "2%",
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                            lineHeight: "24px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            textAlign: "right",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            maxWidth: "180px",
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        {ForwardingDocument.name}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div style={{ gap: "8px", display: "flex" }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    style: "#667085",
                                                                    fontWeight: "500",
                                                                    fontSize: "14px",
                                                                    lineHeight: "19.6px",
                                                                }}
                                                            >
                                                                Airway Bill
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "4px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#6F00FF",
                                                                letterSpacing: "2%",
                                                                fontWeight: "500",
                                                                fontSize: "16px",
                                                                lineHeight: "24px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                textAlign: "right",
                                                                textAlign: "right",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                maxWidth: "180px",
                                                                overflow: "hidden",
                                                            }}
                                                        >
                                                            {waybill.name}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div style={{ gap: "8px", display: "flex" }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    style: "#667085",
                                                                    fontWeight: "500",
                                                                    fontSize: "14px",
                                                                    lineHeight: "19.6px",
                                                                }}
                                                            >
                                                                Insurance ceritifcate
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "4px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#6F00FF",
                                                                letterSpacing: "2%",
                                                                fontWeight: "500",
                                                                fontSize: "16px",
                                                                lineHeight: "24px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                textAlign: "right",
                                                                textAlign: "right",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                maxWidth: "180px",
                                                                overflow: "hidden",
                                                            }}
                                                        >
                                                            {InsuranceCertificate.name}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div style={{ gap: "8px", display: "flex" }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    style: "#667085",
                                                                    fontWeight: "500",
                                                                    fontSize: "14px",
                                                                    lineHeight: "19.6px",
                                                                }}
                                                            >
                                                                Packing List
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "4px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#6F00FF",
                                                                letterSpacing: "2%",
                                                                fontWeight: "500",
                                                                fontSize: "16px",
                                                                lineHeight: "24px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                textAlign: "right",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                maxWidth: "180px",
                                                                overflow: "hidden",
                                                            }}
                                                        >
                                                            {PackingList.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            disabled={isdisable}
                                            onclick={() => {
                                                setshowModal3(true);
                                            }}
                                            variant="primary"
                                            style={{
                                                maxWidth: "280px",
                                                width: "100%",
                                                marginTop: "20px",
                                                background: isdisable ? "#EBE4FF" : "#6F00FF",
                                                padding: "16px 24px 16px 24px",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "8px",
                                                fontSize: "16px",
                                                lineHeight: "24px",
                                                letterSpacing: "2%",
                                                fontWeight: "500",
                                                color: isdisable ? "#BFA6FF" : "#ffff",
                                                marginBottom: "100px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {loader === true ? <Loader data={loader} /> : "Submit"}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default TradeDocument;
